import { allStabilizerMetricNames } from '@shared_types/metrics/stabilizer_metrics'
import { initializeMetrics } from '@shared_utils/metric_utils'

import { LOAD_STABILIZERS, UPDATE_STABILIZERS } from '../actions'

const initialState = initializeMetrics(allStabilizerMetricNames)

// @TODO fix types
export default function init (previousState = initialState, { type, payload }: { type: string; payload: unknown }) {
  if (type === LOAD_STABILIZERS || type === UPDATE_STABILIZERS) {
    console.log('init stabilizer_metrics', payload)
    return Object.assign({}, previousState, payload)
  } else {
    return previousState
  }
}
